import React from "react"

import PropTypes from "prop-types"
import {Image} from "semantic-ui-react"

import "./responsiveLogo.scss"

export const RESPONSIVE_LOGO_VARIANTS = {DEFAULT: "default", HEADER: "header"}

const ResponsiveLogo = ({
    alt = "Logo",
    fixedWidth = true,
    onClick,
    src,
    style,
    variant = RESPONSIVE_LOGO_VARIANTS.DEFAULT,
    ...props
}) => {
    return (
        <div
            className={`responsive-logo variant-${variant}${fixedWidth ? " fixed-width" : ""}${onClick ? " clickable" : ""}`}
            onClick={onClick}
            style={style}
        >
            <Image alt={alt} src={src} tabIndex={onClick ? 0 : -1} {...props} />
        </div>
    )
}

ResponsiveLogo.propTypes = {
    alt: PropTypes.string,
    fixedWidth: PropTypes.bool,
    onClick: PropTypes.func,
    src: PropTypes.string.isRequired,
    style: PropTypes.object,
    variant: PropTypes.oneOf(Object.values(RESPONSIVE_LOGO_VARIANTS)),
}

export default ResponsiveLogo
